module.exports = __webpack_public_path__ + "static/media/summary.3140d347.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/summary.jpg
// module id = 731
// module chunks = 0